import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import {colors, borders, shadows} from "./colors";

const ConfirmDialog = ({
                         open,
                         onClose,
                         onConfirm,
                         title = "האם אתה בטוח?",
                         description = "",
                         confirmText = "מחק",
                         cancelText = "בטל",
                         variant = "danger",
                         icon,
                       }) => {
  const confirmBg = variant === "danger" ? colors.danger : variant === "warning" ? colors.warning : colors.primary;
  const confirmHover = variant === "danger" ? colors.errorText : variant === "warning" ? colors.warningText : colors.primaryDark;

  return (
      <Dialog
          open={open}
          onClose={onClose}
          PaperProps={{
            sx: {
              borderRadius: borders.radius.xl,
              minWidth: "360px",
              padding: "8px",
              boxShadow: shadows.lg,
            },
          }}
      >
        <DialogContent sx={{textAlign: "center", paddingBottom: "8px"}}>
          {icon && <div style={{marginBottom: "12px"}}>{icon}</div>}
          <DialogTitle
              sx={{
                padding: "8px 0",
                fontSize: "18px",
                fontWeight: 700,
                color: colors.textPrimary,
              }}
          >
            {title}
          </DialogTitle>
          {description && (
              <DialogContentText sx={{fontSize: "14px", color: colors.textSecondary}}>
                {description}
              </DialogContentText>
          )}
        </DialogContent>
        <DialogActions sx={{display: "flex", justifyContent: "center", gap: 1, paddingBottom: "16px"}}>
          <Button
              variant="outlined"
              onClick={onClose}
              sx={{
                borderColor: colors.border,
                color: colors.textSecondary,
                borderRadius: borders.radius.md,
                textTransform: "none",
                fontWeight: 600,
                "&:hover": {
                  borderColor: colors.borderHover,
                  backgroundColor: colors.bg,
                },
              }}
          >
            {cancelText}
          </Button>
          <Button
              variant="contained"
              onClick={onConfirm}
              sx={{
                backgroundColor: confirmBg,
                borderRadius: borders.radius.md,
                textTransform: "none",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: confirmHover,
                },
              }}
          >
            {confirmText}
          </Button>
        </DialogActions>
      </Dialog>
  );
};

export default ConfirmDialog;
